/* eslint prefer-arrow-callback: [ "error", { "allowNamedFunctions": true } ] */
/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import PropTypes from 'prop-types'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
))

export default function SlideDialog(props) {
  const {
    open,
    onClose,
    children,
  } = props

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      {children}
    </Dialog>
  )
}

SlideDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
}

SlideDialog.defaultProps = {
  open: false,
}
